<!-- Global nav for review. It has two modes based on if reciever or review. Comes from the input variable -->
<template>
    <div class="navigation-row-container">
        <div class="left-side">
            <div class="main-text">
                <InlineSvg :src="logo" />
                <div>Job fit checker</div>
            </div>
            <div class="limit-container">
                <LimitTag v-if="hasUser && !isUserPremiumOrVip" :ai-feature="AiFeatures.JOB_FIT_CHECKER" />
            </div>

        </div>

        <div class="right-side">
            <div class="button-container">
                <NavBarPill v-if="activeContent === 'previousResults'" label="Back to current result" icon-name="back" @button-clicked="$emit('changeSidebar', 'jfcResult')" dark-scheme />
                <NavBarPill label="Restart" icon-name="restart" @button-clicked="$emit('changeSidebar', 'jobDescription')" dark-scheme />
                <NavBarPill v-if="previousJFCResults?.length" label="Previous results" icon-name="history-clock" @button-clicked="$emit('changeSidebar', 'previousResults')" :active="activeContent === 'previousResults'" dark-scheme />
            </div>
        </div>
    </div>
</template>

<script>
import uxFolioLogoSymbol from "../../../../images/logo-symbol-white.svg";
import InlineSvg from "vue-inline-svg";
import CtaButton from "../../../common/components/CtaButton.vue";
import Icon from "../../../common/Icon.vue";
import NavBarPill from "../../../common/editorNavBar/NavBarPill.vue";
import {mapGetters} from "vuex";
import LimitTag from "../../../portfolioEditor/modals/caseStudyGenerator/components/LimitTag.vue";
import {AiFeatures} from "../../../common/enums.js";

export default {
    name: "JFCNavigation",
    emits: ["changeSidebar"],
    props: {
        activeContent: {
            type: String,
        }
    },
    components: {
        LimitTag,
        NavBarPill,
        Icon,
        CtaButton,
        InlineSvg
    },
    data() {
        return {
            logo: uxFolioLogoSymbol,
        }
    },
    computed: {
        AiFeatures() {
            return AiFeatures
        },
        ...mapGetters("jfc", ["previousJFCResults"]),
        hasUser() {
            console.log(this.$store.state.user)
            return this.$store.state.user != null;
        },
        isUserPremiumOrVip() {
            console.log(this.$store.getters.userIsPremium)
            console.log(this.$store.getters.userIsVIP)
            return this.$store.getters.userIsPremium || this.$store.getters.userIsVIP;
        },
    }
}
</script>

<style scoped lang="scss">

:deep(.limit-tag-container) {
    .popover {
        top: 56px;
        left: 0;
        right: unset;
    }
}

.navigation-row-container {
    height: 60px;
    padding: 12px 24px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;

    background-color: var(--asphalt95);
    border-top: 1px solid var(--asphalt90);
    border-bottom: 1px solid var(--asphalt70);
    z-index: 101;
    display: flex;

    //Default font settings
    color: var(--asphalt10);

    .left-side {
        display: flex;
        align-items: center;
        gap: 16px;

        .main-text {
            display: flex;
            gap: 10px;
            align-items: center;


            svg {
                width: 34px;
                height: 24px;
            }

            div {
                color: var(--asphalt10);
                font: var(--review-ui-b1-medium);
            }
        }
    }

    .right-side {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        gap: 10px;

        .button-container {
            display: flex;
            gap: 8px;
        }
    }
}
</style>